module.exports = __webpack_public_path__ + "static/media/nailbed-dark.f1ef9e91.png";